<template>
  <section class="page-container">
    <div class="admin-main">
      <el-container>
        <el-aside class="cat-aside">
          <el-tree
            :data="treeData"
            :props="treeProps"
            node-key="id"
            highlight-current
            :default-expanded-keys="[0]"
            :expand-on-click-node="false"
            :current-node-key="0"
            @node-click="treeNodeClick"
          >
          </el-tree>
        </el-aside>
        <el-main class="cat-main">
          <div class="admin-toolbar">
            <el-button type="primary" size="small" @click="showCreateDialog"
              >{{
                filters.parentId > 0 && filters.parentName
                  ? `在【${filters.parentName}】下创建分类`
                  : "创建顶级分类"
              }}
            </el-button>
            <el-button type="success" size="small" @click="refresh">刷新</el-button>
            <el-button type="danger" size="small" @click="showPopularBrand">热门品牌</el-button>
          </div>
          <el-table :data="results" border style="width: 100%">
            <el-table-column prop="id" label="编号" width="180" />
            <el-table-column prop="name" label="名称" width="180" />
            <el-table-column prop="parentId" label="父分类ID" width="180" />
            <el-table-column prop="image" label="图片">
              <template slot-scope="scope">
                <el-image
                  style="width: 50px; height: 50px"
                  :src="scope.row.image"
                  :preview-src-list="[scope.row.image]"
                  fit="cover"
                  lazy
                >
                </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="sortNo" label="排序" />
            <el-table-column prop="status" label="状态">
              <template slot-scope="scope">{{ scope.row.status | status }}</template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间">
              <template slot-scope="scope">{{ scope.row.createTime | formatDate }}</template>
            </el-table-column>
            <el-table-column label="操作" width="220">
              <template slot-scope="scope">
                <el-button size="mini" @click="showUpdateDialog(scope.row.id)">编辑 </el-button>
                <el-button size="mini" type="danger" @click="deleteItem(scope.row.id)"
                  >删除
                </el-button>
                <el-button
                  v-if="scope.row.level === 3"
                  size="mini"
                  type="primary"
                  @click="showPushDialog(scope.row.id)"
                  >推送</el-button
                >
              </template>
            </el-table-column>
          </el-table>

          <my-pagination
            :page="page"
            @current-change="handlePageChange"
            @size-change="handleLimitChange"
          />
        </el-main>
      </el-container>
    </div>

    <el-dialog title="创建" width="80%" :visible.sync="dialogCreateVisible">
      <el-form :key="createFormKey" :model="createForm" label-position="right" label-width="80px">
        <el-form-item label="父分类ID">
          <el-input v-model="createForm.parentId" disabled autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="createForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="图片：">
          <image-upload v-model="createForm.image" />
        </el-form-item>
        <el-form-item label="排序：">
          <el-input-number
            v-model="createForm.sortNo"
            placeholder="排序，越小越靠前"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="状态：">
          <status-select v-model="createForm.status" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeCreateDialog">取 消</el-button>
        <el-button type="primary" @click="submitCreate">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="dialogUpdateVisible">
      <el-form :key="updateFormKey" :model="updateForm" label-position="right" label-width="80px">
        <el-form-item label="父分类ID">
          <el-input v-model="updateForm.parentId" disabled autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="名称：">
          <el-input v-model="updateForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="图片：">
          <image-upload v-model="updateForm.image" />
        </el-form-item>
        <el-form-item label="排序：">
          <el-input-number
            v-model="updateForm.sortNo"
            placeholder="排序，越小越靠前"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="状态：">
          <status-select v-model="updateForm.status" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeUpdateDialog">取 消</el-button>
        <el-button type="primary" @click="submitUpdate">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="推送" :visible.sync="dialogPushVisible">
      <el-form :model="pushForm" label-position="right" label-width="100px">
        <el-form-item label="分类ID：">
          <el-input v-model="pushForm.catId" disabled></el-input>
        </el-form-item>
        <el-form-item label="用户ID：">
          <el-input v-model="pushForm.userId" placeholder="留空表示推送全部用户"></el-input>
        </el-form-item>
        <el-form-item label="消息内容：">
          <el-input v-model="pushForm.alert" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closePushDialog">取 消</el-button>
        <el-button type="primary" @click="submitPush">确 定</el-button>
      </div>
    </el-dialog>

    <popular-brand ref="popularBrand" />
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
import ImageUpload from "@/components/ImageUpload";
import StatusSelect from "@/components/StatusSelect";
import PopularBrand from "../popular-brand/index";

export default {
  name: "ProductCategory",
  components: { MyPagination, ImageUpload, StatusSelect, PopularBrand },
  data() {
    return {
      treeProps: {
        label: "name",
      },

      createFormKey: null,
      dialogCreateVisible: false,
      createForm: {
        name: "",
        image: "",
        sortNo: 0,
        status: 0,
        parentId: 0,
      },

      updateFormKey: null,
      dialogUpdateVisible: false,
      updateForm: {
        id: 0,
        name: "",
        image: "",
        sortNo: 0,
        status: 0,
        parentId: 0,
      },

      dialogPushVisible: false,
      pushForm: {
        userId: null,
        catId: null,
        alert: null,
      },

      filters: {
        parentId: 0,
        parentName: "",
      },
      results: [],
      page: {},

      treeData: [],
    };
  },
  watch: {
    createForm(value) {
      console.log(value);
    },
  },
  mounted() {
    this.loadCategoriesTree();
    this.list();
  },
  methods: {
    showPopularBrand() {
      this.$refs.popularBrand.show();
    },
    async list() {
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      const data = await this.axios.form("mall:/api/admin/product-category/list", params);
      this.results = data.results;
      this.page = data.page;
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    showCreateDialog() {
      this.createFormKey = new Date().getTime();
      this.createForm = {
        name: "",
        image: "",
        sortNo: 0,
        status: 0,
        parentId: this.filters.parentId,
      };
      this.dialogCreateVisible = true;
    },
    closeCreateDialog() {
      this.dialogCreateVisible = false;
    },
    async submitCreate() {
      try {
        await this.axios.post("mall:/api/admin/product-category/create", this.createForm);
        await this.list();
        await this.loadCategoriesTree();
        this.dialogCreateVisible = false;
      } catch (e) {
        this.$message.error(e.message || "提交失败");
      }
    },
    async showUpdateDialog(id) {
      try {
        this.updateFormKey = new Date().getTime();
        this.updateForm = await this.axios.get("mall:/api/admin/product-category/" + id);
        this.dialogUpdateVisible = true;
      } catch (e) {
        this.$message.error(e.message || "获取数据失败");
      }
    },
    async deleteItem(id) {
      try {
        await this.axios.delete("mall:/api/admin/product-category/" + id);
        await this.refresh();
        this.$message.error("删除成功");
      } catch (e) {
        this.$message.error(e.message || "获取数据失败");
      }
    },
    closeUpdateDialog() {
      this.dialogUpdateVisible = false;
    },
    async submitUpdate() {
      try {
        await this.axios.post("mall:/api/admin/product-category/update", this.updateForm);
        await this.list();
        await this.loadCategoriesTree();
        this.closeUpdateDialog();
      } catch (e) {
        this.$message.error(e.message || "修改失败");
      }
    },
    showPushDialog(catId) {
      this.pushForm = {
        userId: null,
        catId: catId,
        alert: null,
      };
      this.dialogPushVisible = true;
    },
    closePushDialog() {
      this.dialogPushVisible = false;
    },
    async submitPush() {
      try {
        await this.axios.form("base:/api/admin/push/product_cat", this.pushForm);
        this.closePushDialog();
        this.$message.success("推送请求提交成功");
      } catch (e) {
        this.$message.error(e.message || "推送失败");
      }
    },
    async loadCategoriesTree() {
      try {
        const children = await this.axios.get("mall:/api/admin/product-category/tree");
        this.treeData = [
          {
            id: 0,
            name: "全部分类",
            children: children,
          },
        ];
      } catch (e) {
        this.$message.error(e.message || "数据加载时报");
      }
    },
    async treeNodeClick(data) {
      this.filters.parentId = data.id;
      this.filters.parentName = data.name;
      await this.list();
    },
    async refresh() {
      await this.loadCategoriesTree();
      await this.list();
    },
  },
};
</script>

<style lang="scss" scoped>
.admin-main {
  padding: 20px;

  .cat-aside {
    background-color: #fff;
    border: 1px solid #ddd;
  }
  .cat-main {
    padding: 0;
    margin-left: 10px;
  }

  .admin-toolbar {
    margin-bottom: 10px;
  }
}
</style>
